import { getContactStateKey } from 'clickNgo/entities/contact/lib/helpers'
import { IContactFlags } from 'clickNgo/entities/contactFlag'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'
import { IForm } from 'core-components/classes/models/IForm'

import { ContactState, IContact } from '../../model/types'

import { mapContactFromContactAllData } from './mapContactFromContactAllData'

export const mapContactState = (data: IForm[]): ContactState => {
  const contactState: ContactState = {
    contactsById: {},
    contactFlagsById: {},
    allContactIds: [],
  }

  data.forEach((item) => {
    const contact: IContact = mapContactFromContactAllData(item)
    const contactStateKey = getContactStateKey(contact)
    const flags: IContactFlags = {
      [ProfilingCodeType.Campaigns]: item['Campaigns']
        ? item['Campaigns'].split(',').map((c: string) => ({
            code: c.trim(),
            contactId: contact.contactId,
            type: ProfilingCodeType.Campaigns,
            entryId: 0,
          }))
        : [],

      [ProfilingCodeType.Tools]: item['Tools']
        ? item['Tools'].split(',').map((c: string) => ({
            code: c.trim(),
            contactId: contact.contactId,
            type: ProfilingCodeType.Tools,
            entryId: 0,
          }))
        : [],
      [ProfilingCodeType.UserRights]: item['UserRights']
        ? item['UserRights'].split(',').map((c: string) => ({
            code: c.trim(),
            contactId: contact.contactId,
            type: ProfilingCodeType.UserRights,
            entryId: 0,
          }))
        : [],
    }
    contactState.contactsById[contactStateKey] = contact
    contactState.contactFlagsById[contactStateKey] = flags
    contactState.allContactIds.push(contactStateKey)
  })

  return contactState
}
